import {
  CASE_DELETE_FILE_VERSIONS_BEGIN,
  CASE_DELETE_FILE_VERSIONS_SUCCESS,
  CASE_DELETE_FILE_VERSIONS_FAILURE,
  CASE_DELETE_FILE_VERSIONS_DISMISS_FEEDBACK,
} from './constants';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';

export const deleteFileVersions = createPromiseAction(CASE_DELETE_FILE_VERSIONS_BEGIN);

export function dismissDeleteFileVersionsFeedback() {
  return {
    type: CASE_DELETE_FILE_VERSIONS_DISMISS_FEEDBACK,
  };
}

export function* doDeleteFileVersions(action) {
  const { caseId, fileId, versions } = action.payload;

  let res = yield call(api.del, `/cases/${caseId}/files/${fileId}/versions`, versions);

  if (res && res.error) {
    yield put({
      type: CASE_DELETE_FILE_VERSIONS_FAILURE,
      feedback: {
        message: 'feedback.deleteFileVersionsFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_DELETE_FILE_VERSIONS_SUCCESS,
    data: { fileVersions: res },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchDeleteFileVersions() {
  yield takeLatest(deleteFileVersions, withCurrentCaseId(doDeleteFileVersions));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_DELETE_FILE_VERSIONS_BEGIN + '.TRIGGER':
      // Just after a request is sent
      return {
        ...state,
        deleteFileVersionsPending: true,
        deleteFileVersionsFeedback: null,
      };

    case CASE_DELETE_FILE_VERSIONS_SUCCESS:
      // The request is success
      return {
        ...state,
        deleteFileVersionsPending: false,
        deleteFileVersionsFeedback: action.feedback,
      };

    case CASE_DELETE_FILE_VERSIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteFileVersionsPending: false,
        deleteFileVersionsFeedback: action.feedback,
      };

    case CASE_DELETE_FILE_VERSIONS_DISMISS_FEEDBACK:
      // Dismiss the request failure Feedback
      return {
        ...state,
        deleteFileVersionsFeedback: null,
      };

    default:
      return state;
  }
}
